export const USE_NEW_UPLOAD_UI =
  String(process.env.REACT_APP_USE_NEW_UPLOAD_UI || "false").toLowerCase() ===
  "true";
